"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateForm = void 0;
const types_1 = require("./types");
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_REGEX = /^[+]?[\d\s()-]{7,15}$/;
/**
 * Validates all form data against the form definition.
 * Returns a map of fieldKey → error message. Empty map = valid.
 */
function validateForm(definition, data) {
    const errors = {};
    for (const section of definition.sections) {
        validateSection(section, data, errors);
    }
    return errors;
}
exports.validateForm = validateForm;
function validateSection(section, data, errors) {
    // Generic sections with fields array
    if (section.fields) {
        for (const field of section.fields) {
            validateField(field, data[field.key], errors);
        }
    }
    // Specialized sections
    switch (section.type) {
        case 'family':
            validateFamilySection(section, data, errors);
            break;
        case 'address':
            validateAddressSection(section, data, errors);
            break;
        case 'education':
            validateRepeatableSection('education', section.fields || [], data.education, errors);
            break;
        case 'workExperience':
            validateRepeatableSection('workExperience', section.fields || [], data.workExperience, errors);
            break;
    }
}
function validateField(field, value, errors) {
    const isEmpty = value === null || value === undefined || value === '';
    // Required check
    if (field.required && isEmpty) {
        errors[field.key] = `${field.label} is required`;
        return;
    }
    if (isEmpty)
        return; // Skip further validation on empty optional fields
    // Type-specific validation
    switch (field.type) {
        case 'email':
            if (!EMAIL_REGEX.test(String(value))) {
                errors[field.key] = 'Invalid email address';
            }
            break;
        case 'phone':
            if (!PHONE_REGEX.test(String(value))) {
                errors[field.key] = 'Invalid phone number';
            }
            break;
        case 'date':
            if (field.validation?.minDate || field.validation?.maxDate) {
                const dateVal = new Date(value);
                if (field.validation.minDate) {
                    const min = new Date(field.validation.minDate);
                    if (dateVal < min)
                        errors[field.key] = `Date must be after ${field.validation.minDate}`;
                }
                if (field.validation.maxDate) {
                    const max = new Date(field.validation.maxDate);
                    if (dateVal > max)
                        errors[field.key] = `Date must be before ${field.validation.maxDate}`;
                }
            }
            break;
    }
    // Pattern validation
    if (field.validation?.pattern && value) {
        const regex = new RegExp(field.validation.pattern);
        if (!regex.test(String(value))) {
            errors[field.key] = `${field.label} format is invalid`;
        }
    }
}
function validateFamilySection(section, data, errors) {
    const familyData = data.family || [];
    for (let i = 0; i < section.contacts.length; i++) {
        const contact = section.contacts[i];
        const contactData = familyData[i] || {};
        for (const rawField of contact.fields) {
            const field = (0, types_1.resolveFamilyField)(rawField);
            if (field.required && !contactData[field.key]) {
                errors[`family.${i}.${field.key}`] = `${field.label} is required`;
            }
        }
    }
}
function validateAddressSection(section, data, errors) {
    const addresses = data.addresses || [];
    for (let i = 0; i < section.addresses.length; i++) {
        const addrConfig = section.addresses[i];
        const addrData = addresses[i] || {};
        for (const field of addrConfig.fields) {
            if (field.required && !addrData[field.key]) {
                errors[`addresses.${i}.${field.key}`] = `${field.label} is required`;
            }
        }
    }
}
function validateRepeatableSection(sectionKey, fields, rows, errors) {
    if (!rows)
        return;
    for (let i = 0; i < rows.length; i++) {
        const row = rows[i] || {};
        for (const field of fields) {
            if (field.required && !row[field.key]) {
                errors[`${sectionKey}.${i}.${field.key}`] = `${field.label} is required`;
            }
        }
    }
}
